module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "sidebar"
  }, [_c('el-col', {
    staticClass: "full-height",
    attrs: {
      "span": 4
    }
  }, [_c('el-menu', {
    staticClass: "full-height",
    attrs: {
      "default-active": "2",
      "unique-opened": true
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v("概述")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v("文章管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/post/list"
    }
  }, [_vm._v("文章列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/post/create"
    }
  }, [_vm._v("添加文章")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("页面管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/page/list"
    }
  }, [_vm._v("页面列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/page/create"
    }
  }, [_vm._v("添加页面")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v("主题管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/theme/list"
    }
  }, [_vm._v("主题列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/theme/create"
    }
  }, [_vm._v("编辑主题")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _vm._v("分类管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/cate/list"
    }
  }, [_vm._v("分类列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/cate/create"
    }
  }, [_vm._v("添加分类")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _vm._v("标签管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/tag/list"
    }
  }, [_vm._v("标签列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/tag/create"
    }
  }, [_vm._v("添加标签")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _vm._v("音乐管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/music/list"
    }
  }, [_vm._v("音乐列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/music/create"
    }
  }, [_vm._v("添加音乐")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/user/edit"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _vm._v("用户设置")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "9"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v("系统设置")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/option/general"
    }
  }, [_vm._v("基本设置")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/option/comment"
    }
  }, [_vm._v("评论设置")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/option/analytic"
    }
  }, [_vm._v("统计代码")])], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-10f3745e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Sidebar.vue
// module id = bEjz
// module chunks = 1